'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextColor = getTextColor;
exports.useDefaultElementColor = useDefaultElementColor;

var _colors = require('HubStyleTokens/colors');

var _HexCode = require('PatternValidationJS/patterns/HexCode');

var _HexCode2 = _interopRequireDefault(_HexCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getL(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  var r = parseInt(result[1], 16) / 255.0;
  var rL = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  var g = parseInt(result[2], 16) / 255.0;
  var gL = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  var b = parseInt(result[3], 16) / 255.0;
  var bL = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  return 0.2126 * rL + 0.7152 * gL + 0.0722 * bL;
}

function canReadText(backgroundHex, textColor) {
  var backL = getL(backgroundHex);
  var textL = getL(textColor);

  var contrastRatio = (textL + 0.05) / (backL + 0.05);

  return contrastRatio > 2.0;
}

var canReadTextVal = void 0;
var lastAccent = void 0;

function getCanReadTextOnce(accent) {
  if (accent !== lastAccent) {
    lastAccent = accent;
    canReadTextVal = canReadText(accent, _colors.OLAF);
  }
  return canReadTextVal;
}

function getTextColor(accent) {
  if (!_HexCode2.default.test(accent)) {
    return _colors.OBSIDIAN;
  }
  return getCanReadTextOnce(accent) ? _colors.OLAF : _colors.OBSIDIAN;
}

function useDefaultElementColor(accent) {
  if (!_HexCode2.default.test(accent)) {
    return true;
  }
  return !getCanReadTextOnce(accent);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/textColorUtils.js
// module id = 296
// module chunks = 0 1